import { useMemo } from "react";
import { cn } from "@/lib/utils";

const AVATAR_COLORS = ["#1F5A9E", "#2D8D57", "#8C3D99", "#339AA6", "#E85C3A", "#192F66"];

function initialsFor(email: string): string {
  const name = (email || "?").split("@")[0].replace(/[.+_-]/g, " ");
  const parts = name.split(/\s+/).filter(Boolean).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
}

export function Avatar({
  email,
  size = 32,
  className,
}: {
  email: string;
  size?: number;
  className?: string;
}) {
  const initials = useMemo(() => initialsFor(email), [email]);
  const bg = useMemo(() => {
    let h = 0;
    for (let i = 0; i < email.length; i++) h = (h * 31 + email.charCodeAt(i)) >>> 0;
    return AVATAR_COLORS[h % AVATAR_COLORS.length];
  }, [email]);

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white",
        className,
      )}
      style={{ width: size, height: size, background: bg, fontSize: Math.round(size * 0.4) }}
      title={email}
    >
      {initials}
    </span>
  );
}
